import React from 'react';
import StepHeader from 'components/common/headers/StepHeader';
import { observer } from 'mobx-react-lite';
import SendOutEmailsModal from 'components/common/modals/SendOutEmailsModal';
import { useEmployeeSelfRegisterLinkPageStore } from 'store/pages/utility/employee-self-register-link/pageStore';
import { SHARE_LINK_BUTTON_TEST_ID, SEND_OUT_SELF_REGISTER_LINKS_FORM_ID } from '../constants';
import { ActionButtonStyled, StepSubtitleStyled, StepWrapperStyled } from './styles';

export const ShareLinkStep: React.FC = observer(() => {
  const { sendOutEmailsModalStore } = useEmployeeSelfRegisterLinkPageStore();
  return (
    <>
      <StepWrapperStyled>
        <StepHeader
          stepNumber="2"
          stepTitle="Share Registration Link"
          stepSubtitle={
            <StepSubtitleStyled>
              Send the registration link directly to a contact who can distribute it to employees for self-registration.
              The email includes instructions to guide them through the process.
            </StepSubtitleStyled>
          }
        />
        <ActionButtonStyled
          color="primary"
          size="large"
          onClick={sendOutEmailsModalStore.open}
          data-test-id={SHARE_LINK_BUTTON_TEST_ID}
        >
          Share Link
        </ActionButtonStyled>
      </StepWrapperStyled>
      <SendOutEmailsModal
        title="Share Registration Link"
        subtitle="Send the registration link to the person who manages employee distribution."
        modalStore={sendOutEmailsModalStore}
        formId={SEND_OUT_SELF_REGISTER_LINKS_FORM_ID}
        withMessage
      />
    </>
  );
});
